module.exports = __webpack_public_path__ + "static/img/card-002.e1e3caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-002.png
// module id = GcQW
// module chunks = 1